
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import moment from "moment";
import PropTypes from "prop-types";
import { createSelector } from "reselect";

import { OpenPopup } from "../../../actions/ui";
import Helpers from "../../../helpers/helperFunctions";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { getGamesSubscriptionRequest } from "../../../helpers/terminalRequests/virtualSportsHelpers";

function mouseUpHandler () {
    clearTimeout(this.timerScroll);
    this.clickedSportsList = true;
    this.delta = 0;
    document.removeEventListener("mouseup", mouseUpHandler);
}

let ctx;

class VirtualGamesList extends Component {
    constructor (props) {
        super(props);
        this.state = {};
        this.selectGame = this.selectGame.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick () {
        const { virtualsParams } = this.props;
        virtualsParams && this.props.dispatch(OpenPopup("videoStream", virtualsParams));
    }
    UNSAFE_componentWillReceiveProps (nextProps) {
        if (nextProps.data) {
            let games = Helpers.objectToArray(nextProps.data.game);
            const selectedGame = nextProps.data.game[this.state.selectedGameId]

            if (!selectedGame) {
                this.setState({
                    selectedGameId: this.state.defaultGameId
                });
            }

            const nextGame = games.find(game => game.market && game.id !== selectedGame?.id)

            if (nextGame)
                this.setState({
                    defaultGameId: nextGame.id
                })
        }
    }
    handleMouseUp () {
        document.addEventListener("mouseup", mouseUpHandler.bind(this));
    }
    scroll (scroller, scrollSize, delay) {
        let iterator = scrollSize > 0 ? 0.1 : -0.1;
        this.delta = this.delta || iterator;
        this.delta += iterator;
        this.clickedSportsList = false;
        scroller.scrollLeft += (scrollSize + this.delta);
        this.timerScroll = setTimeout(() => {
            !this.clickedSportsList && this.scroll(scroller, scrollSize, delay);
        }, delay);
    }
    selectGame (selectedGameId) {
        this.setState({selectedGameId});
    }
    render () {
        ctx = this.props;
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_, ownParams) => {
    let key = getSwarmDataKeyForRequest(getGamesSubscriptionRequest(ownParams.competitionId));
    return createSelector(
        [
            state => state.swarmData.loaded[key],
            state => state.swarmData.data[key] && JSON.stringify(state.swarmData.data[key]),
            state => state.uiState.virtualsParams
        ],
        (loaded, data, virtualsParams) => {
            let gamesWithMarkets

            if (data) {
                const games = JSON.parse(data)
                gamesWithMarkets = { game: {} }

                for (const key in games.game) {
                    const currGame = games.game[key]
                    if (currGame.market && currGame.start_ts > moment().unix())
                        gamesWithMarkets.game[key] = currGame
                }
            }

            return {
                data: gamesWithMarkets,
                loaded,
                virtualsParams
            };
        });
};

VirtualGamesList.propTypes = {
    competitionId: PropTypes.number,
    data: PropTypes.object,
    loaded: PropTypes.bool,
    providerId: PropTypes.number,
    virtualsParams: PropTypes.object
};
export default withRouter(connect(mapStateToProps)(SwarmDataMixin({
    Component: VirtualGamesList,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getGamesSubscriptionRequest(this.props.competitionId);
        this.swarmDataKey = getSwarmDataKeyForRequest(getGamesSubscriptionRequest(this.props.competitionId));
    },
    ComponentWillReceiveProps: function (nextProps) {
        if (!nextProps.params.competitionId && nextProps.firstCompetitionId) {
            if (ctx && nextProps.location.pathname.indexOf(nextProps.firstCompetitionId) === -1) {
                return ctx.router.replace(nextProps.location.pathname + "/" + nextProps.firstCompetitionId);
            }
        }
    }
})));